import React, { useState } from 'react';
import { Edit, Trash, PlusCircle, Edit2, Link, BookOpen } from 'react-feather';
import { Tooltip, Button } from 'antd';
import classes from './ActionButtons.module.scss';
import { ReactComponent as RequestQuoteOutlined } from '../../assets/images/icons/material-icons/request-quote-outlined.svg';

export const ActionButtons = (props) => {
  const {
    Edit,
    editOnClick,
    editTooltip,
    editDisabled,
    editIconSize,
    Delete,
    deleteOnClick,
    deleteTooltip,
    deleteDisabled,
    deleteIconSize,
    deleteIconStyle,
    Link,
    linkOnClick,
    linkToolTip,
    linkDisabled,
    linkIconSize,
    linkIconStyle,
    UpdateMilestonesReason,
    reasonOnClick,
    reasonToolTip,
    reasonDisabled,
    reasonIconSize,
    reasonIconStyle,
    Add,
    addOnClick,
    addTooltip,
    addDisabled,
    addIconSize,
    billingIconStyle,
    applyStyling,
    customCssOnboarding,
    type,
    action,
  } = props;
  return (
    <>
      <span className={applyStyling ? `${classes.wrapper} ${customCssOnboarding}` : `${classes.wrapper} ${classes.muiBtn}`}>
        {Edit && <EditActionButton onClick={editOnClick} tooltip={editTooltip} disabled={editDisabled} size={editIconSize} />}
        {type !== 'Billing' && Add && (
          <AddActionButton onClick={addOnClick} tooltip={addTooltip} disabled={addDisabled} className={Add ? classes.isSecondIcon : ''} size={addIconSize} />
        )}
        {type === 'Billing' && (
          <ManageActionButton onClick={addOnClick} tooltip={addTooltip} disabled={addDisabled} className={Add ? classes.isSecondIcon : ''} />
        )}
        {action && action !== 'createSlackChannel' && (
          <BillingActionButton onClick={addOnClick} tooltip={addTooltip} disabled={addDisabled} className={Add ? classes.isSecondIcon : ''} size={addIconSize} billingIconStyle={billingIconStyle} />
        )}
        {action && action == 'createSlackChannel' && (
          <SlackChannelActionButton onClick={addOnClick} tooltip={addTooltip} disabled={addDisabled} className={Add ? classes.isSecondIcon : ''} />
        )}
        {Delete && (
          <DeleteActionButton
            onClick={deleteOnClick}
            tooltip={deleteTooltip}
            disabled={deleteDisabled}
            className={Edit ? classes.isSecondIcon : ''}
            size={deleteIconSize}
            deleteStyle={deleteIconStyle}
          />
        )}
        {Link && (
          <LinkActionButton
            onClick={linkOnClick}
            tooltip={linkToolTip}
            disabled={linkDisabled}
            className={Edit ? classes.isSecondIcon : ''}
            size={linkIconSize}
            linkIconStyle={linkIconStyle}
          />
        )}
        {UpdateMilestonesReason && (
          <ReasonForUpdateMilesonteButton
            onClick={reasonOnClick}
            tooltip={reasonToolTip}
            disabled={reasonDisabled}
            className={Edit ? classes.isSecondIcon : ''}
            size={reasonIconSize}
            reasonIconStyle={reasonIconStyle}
          />
        )}
      </span>
    </>
  );
};

ActionButtons.defaultProps = {
  editTooltip: 'Edit',
  deleteTooltip: 'Delete',
  addTooltip: 'Add Project Manager',
  addDisabled: false,
  editDisabled: false,
  deleteDisabled: false,
  linkDisabled: false,
};

const EditActionButton = ({ tooltip, onClick, disabled, size }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button id="editButton" type="text" aria-label="edit" onClick={onClick} disabled={disabled}>
          <Edit className={!disabled ? classes.edit_icon : classes.edit_icon_disabled} style={{ width: `${size}px`, height: `${size}px` }} />
        </Button>
      </Tooltip>
    </>
  );
};

const AddActionButton = ({ tooltip, onClick, disabled, size }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button id="addButton" type="text" aria-label="add" onClick={onClick} disabled={disabled}>
          <PlusCircle
            label="Add"
            className="cursor-pointer icon_size"
            size={size}
            style={{
              color: '#87E64B',
            }}
            disableRipple={true}
          />
        </Button>
      </Tooltip>
    </>
  );
};

const ManageActionButton = ({ tooltip, onClick, disabled }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button id="manageChannelButton" type="text" aria-label="add" onClick={onClick} disabled={disabled}>
          <Edit2
            label="Manage Channel"
            className="cursor-pointer icon_size"
            size={20}
            style={{
              color: '#87E64B',
            }}
            disableRipple={true}
          />
        </Button>
      </Tooltip>
    </>
  );
};

const DeleteActionButton = ({ tooltip, onClick, disabled, className, size, deleteStyle }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button
          id="deleteButton"
          type="text"
          aria-label="delete"
          onClick={onClick}
          disabled={disabled}
          className={`${className} ${!deleteStyle && 'px-25'}`}
          disableRipple={true}
          style={deleteStyle}
        >
          <Trash className={!disabled ? classes.delete_icon : classes.delete_icon_disabled} style={{ width: `${size}px`, height: `${size}px`, ...(deleteStyle?.color ? { color: deleteStyle.color } : {}) }} />
        </Button>
      </Tooltip>
    </>
  );
};

const LinkActionButton = ({ tooltip, onClick, disabled, className, size, linkIconStyle }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button
          id="linkButton"
          type="text"
          aria-label="billing-thread-link"
          onClick={onClick}
          disabled={disabled}
          className={`${className}`}
          // className={`${className} px-25`}
          disableRipple={true}
          style={linkIconStyle}
        >
          <Link
            className={!disabled ? classes.link_icon : classes.link_icon_disabled}
            style={{ width: `${size}px`, height: `${size}px`, opacity: `${disabled ? 0.5 : 1}` }}
            color="#87E64B"
          />
        </Button>
      </Tooltip>
    </>
  );
};

const ReasonForUpdateMilesonteButton = ({ tooltip, onClick, disabled, className, size, reasonIconStyle }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button
          id="updateReasonButton"
          type="text"
          aria-label="update-billing-reason"
          onClick={onClick}
          disabled={disabled}
          className={`${className}`}
          // className={`${className} px-25`}
          disableRipple={true}
          style={reasonIconStyle}
        >
          <BookOpen
            className={!disabled ? classes.link_icon : classes.link_icon_disabled}
            style={{ width: `${size}px`, height: `${size}px`, opacity: `${disabled ? 0.5 : 1}` }}
            color="#87E64B"
          />
        </Button>
      </Tooltip>
    </>
  );
};

const BillingActionButton = ({ tooltip, onClick, disabled, size, billingIconStyle }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button
          id="billingButton"
          type="text"
          aria-label="add"
          onClick={onClick}
          disabled={disabled}
          // className={'px-25'}
          style={billingIconStyle}
        >
          <RequestQuoteOutlined
            label="Billing"
            className={`cursor-pointer ${classes.request_quote_icon}`}
            style={{
              height: `${size}`,
              width: `${size}`,
              opacity: `${disabled ? 0.5 : 1}`
            }}
            disableRipple={true}
          />
        </Button>
      </Tooltip>
    </>
  );
};

const SlackChannelActionButton = ({ tooltip, onClick, disabled }) => {
  return (
    <>
      <Tooltip title={tooltip} placement="bottom">
        <Button id="slackChannelButton" type="text" aria-label="add" onClick={onClick} disabled={disabled}>
          <PlusCircle
            label="Billing"
            className="cursor-pointer"
            style={{
              color: '#87E64B',
              height: '20px',
              width: '20px',
              opacity: `${disabled ? 0.5 : 1}`
            }}
            disableRipple={true}
          />
        </Button>
      </Tooltip>
    </>
  );
};
